import Button from "../../../Components/Common/Button/Button";
import ChartRenderer from "./charts/ChartRenderer";
import DataTable from "./DataTable";
import InsightCallout from "./InsightCallout";
import type { ReportCard } from "../types/reports.types";

interface ContentCardProps {
  card: ReportCard;
  onAction: (message: string) => void;
}

export default function ContentCard({ card, onAction }: ContentCardProps) {
  const cardClass = card.wide ? "contentCard wide" : "contentCard";

  return (
    <article className={cardClass}>
      <div className="contentCardHeader">
        <div>
          <h3 className="contentCardTitle">{card.title}</h3>
          {card.subtitle ? (
            <p className="contentCardSubtitle">{card.subtitle}</p>
          ) : null}
        </div>
        {card.actions?.length ? (
          <div className="contentCardActions">
            {card.actions.map((action) => (
              <Button
                key={action.label}
                className="reportBtn small"
                onClick={() => onAction(action.toast ?? `${action.label} complete`)}
              >
                {action.label}
              </Button>
            ))}
          </div>
        ) : null}
      </div>

      <ChartRenderer chart={card.chart} />
      <DataTable table={card.table} />
      <InsightCallout insight={card.insight} />

      {card.exports?.length ? (
        <div className="exportRow">
          {card.exports.map((action) => (
            <Button
              key={action.label}
              className="reportBtn"
              onClick={() => onAction(action.toast ?? `${action.label} complete`)}
            >
              {action.label}
            </Button>
          ))}
        </div>
      ) : null}
    </article>
  );
}
